module.exports = __webpack_public_path__ + "img/save-money.b7ffe36c.png";